module.exports = __webpack_public_path__ + "img/salon-care-products.9c388c1a.svg";